import { Laptop } from "lucide-react";

export function LocalGatewayOsTabs({ tabId, label, selectedOs, disabled = false, onChange }: {
  tabId: string;
  label: string;
  selectedOs: string;
  disabled?: boolean;
  onChange: (os: string) => void;
}) {
  return (
          <div role="tablist" aria-label={label} className="flex gap-1 border-b border-slate-200">
            {(["windows", "darwin"] as const).map((os, index) => (
              <button key={os} type="button" role="tab" id={`${tabId}-${os}`}
                aria-selected={selectedOs === os} aria-controls={`${tabId}-panel`}
                tabIndex={selectedOs === os || (!selectedOs && index === 0) ? 0 : -1}
                disabled={disabled}
                className={`inline-flex items-center gap-2 border-b-2 px-4 py-2 text-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary disabled:opacity-50 ${selectedOs === os ? "border-primary font-semibold text-primary" : "border-transparent text-muted-foreground hover:text-foreground"}`}
                onClick={() => { onChange(os); }}
                onKeyDown={event => {
                  if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) return;
                  event.preventDefault();
                  const next = event.key === "Home" ? "windows" : event.key === "End" ? "darwin" : os === "windows" ? "darwin" : "windows";
                  onChange(next);
                  document.getElementById(`${tabId}-${next}`)?.focus();
                }}>
                {os === "windows" ? <svg viewBox="0 0 20 20" className="h-4 w-4" fill="currentColor" aria-hidden="true">
                  <path d="M1 3.5 9 2.4v7H1zm9-1.2L19 1v8.4h-9zM1 10.5h8v7L1 16.4zm9 0h9V19l-9-1.3z" />
                </svg> : <Laptop className="h-4 w-4" aria-hidden="true" />}
                {os === "windows" ? "Windows" : "macOS"}
              </button>
            ))}
          </div>
  );
}
